const WEEKLY_PLAN_PREFIX = "aile-cooking-weekly-plan:v1";

function resolveStorage(storage) {
  if (storage) return storage;
  if (typeof window === "undefined") return null;
  try { return window.localStorage; } catch (_) { return null; }
}

function storageKey(familyId, lang) {
  return `${WEEKLY_PLAN_PREFIX}:${encodeURIComponent(String(familyId || "anonymous"))}:${lang === "en" ? "en" : "tr"}`;
}

export function getMealPlanDateKey(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getCurrentWeekDates(date = new Date()) {
  const current = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const mondayOffset = current.getDay() === 0 ? -6 : 1 - current.getDay();
  const monday = new Date(current);
  monday.setDate(current.getDate() + mondayOffset);
  return Array.from({ length: 7 }, (_, index) => {
    const day = new Date(monday);
    day.setDate(monday.getDate() + index);
    return day;
  });
}

export function readWeeklyMealPlan({ familyId, lang = "tr", storage } = {}) {
  const target = resolveStorage(storage);
  if (!target || !familyId) return {};
  try {
    const raw = JSON.parse(target.getItem(storageKey(familyId, lang)) || "{}");
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) return {};
    return Object.fromEntries(Object.entries(raw)
      .filter(([dateKey, menuId]) => /^\d{4}-\d{2}-\d{2}$/.test(dateKey) && Number.isFinite(Number(menuId)))
      .map(([dateKey, menuId]) => [dateKey, Number(menuId)]));
  } catch (_) {
    return {};
  }
}

export function writeWeeklyMealPlan({ familyId, lang = "tr", plan = {}, storage, date = new Date() } = {}) {
  const target = resolveStorage(storage);
  if (!target || !familyId) return false;
  const today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  const minDate = new Date(today);
  const maxDate = new Date(today);
  minDate.setDate(minDate.getDate() - 14);
  maxDate.setDate(maxDate.getDate() + 42);
  const minKey = getMealPlanDateKey(minDate);
  const maxKey = getMealPlanDateKey(maxDate);
  const normalized = Object.fromEntries(Object.entries(plan || {})
    .filter(([dateKey, menuId]) => dateKey >= minKey && dateKey <= maxKey && Number.isFinite(Number(menuId)))
    .map(([dateKey, menuId]) => [dateKey, Number(menuId)]));
  try {
    target.setItem(storageKey(familyId, lang), JSON.stringify(normalized));
    return true;
  } catch (_) {
    return false;
  }
}
